import {CasinofiedApplicationBase} from '../casinofied-application-base';
import {IOpenAppData, IDivHostedAppInitParameters} from '@sparkware/uc-sdk-core';
import {ICasinofiedComponentFactory} from '../../casinofied-app-factory.interfaces';
import {CasinofiedAppSdkLoader} from '../../casinofied-app-sdk-loader';
import {IServiceFactoryExtended} from '../../../../service-factory-extended.interface';
import {SAFEZONE_CONTAINERS_ID, CLOSE_SAFEZONE_SOURCE_VALUES} from '../../../../safezone/safezone.service.interface';
import {getInitAppParamsForControlCenter} from './init-params-helper';
import {IAppInitResultReportingDetails} from '../../../analytics-publisher/casinofied-analytics.service';
import {IAppCloseParams} from '../casinofied-application.interface';
import {ControlCenterAnalyticsHelper} from "./control-center-analytics-helper";

export class ControlCenterMiniApplication extends CasinofiedApplicationBase {

    constructor(openAppData: IOpenAppData,
        _componentFactory: ICasinofiedComponentFactory,
        appSdkLoader: CasinofiedAppSdkLoader,
        services: IServiceFactoryExtended,
        private analyticsHelper: ControlCenterAnalyticsHelper
    ) {
        super(openAppData, _componentFactory, appSdkLoader, services, false);
        this._openAppData.launchInfo.containerID = SAFEZONE_CONTAINERS_ID.MINI_SAFEZONE_CONTAINER_ID;
        // at this moment we dont have appInitParams so we have to rely on IOpenAppData
        this.analyticsHelper.setCorrelationID(openAppData.correlationID).setSource(openAppData.launchInfo.appSpecificParameters.source).trackAppOpen();
    }

    protected _getInitAppParams(initParams: IDivHostedAppInitParameters): IDivHostedAppInitParameters {
        let result = super._getInitAppParams(initParams);
        result = getInitAppParamsForControlCenter(result, this.services);
        /* save here the correlationId and the source for analytics */
        this.analyticsHelper.setCorrelationID(result.correlationID).setSource(result.applicationContext.launchInfo.appSpecificParameters.source);
        return result;
    }

    public close(params: IAppCloseParams) {
        super.close(params);
        // If you wonder why I do analytics here and not using services.messageBroker.channels.session.topics.appClosed.subscribe
        // it is because appClosed is not triggered by safezone when clicking on the mini widget to open the full. It is triggered by me also here.
        // So no point subscribing. If in the future others will trigger appClosed will reconsider this
        if (params.reason === CLOSE_SAFEZONE_SOURCE_VALUES.MINI_SZ) {
            this.analyticsHelper.trackCloseInternal();
        } else if (params.reason === CLOSE_SAFEZONE_SOURCE_VALUES.CLIENT) {
            this.analyticsHelper.trackCloseExternal();
        }
    }

    protected onAppInitSuccess(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitSuccess(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitSuccess();
    }

    protected onAppInitTimeout(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitTimeout(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitFailed()
    }

    protected onAppInitFailed(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitFailed(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitFailed()
    }

}


